/** Full-page Suntronix AI Copilot (/copilot). */
import { useSearchParams } from "react-router-dom";
import CopilotBox from "@/components/app/CopilotBox";

export default function CopilotPage() {
  const [sp] = useSearchParams();
  return (
    <div className="max-w-[1100px] mx-auto px-3 sm:px-4 py-4 sm:py-6 space-y-4" data-testid="copilot-page">
      <div>
        <div className="font-mono text-[10px] font-semibold tracking-[0.18em] uppercase text-sky-600">GPT-5.4 · permission-aware</div>
        <h1 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">Suntronix AI Copilot</h1>
        <p className="text-sm text-slate-500 mt-0.5">Ask in plain English. Every answer is built from records your role may see, and every row links to the source. Copilot never changes records without your confirmation.</p>
      </div>
      <CopilotBox initialQuestion={sp.get("q") || ""} />
    </div>
  );
}
